import { search as search1 } from './api/report';
import { setMessage } from './utils';

export const START_SEARCH = 'START_SEARCH';
export const SEARCH_COMPLETE = 'SEARCH_COMPLETE';
export const SEARCH_ERROR = 'SEARCH_ERROR';

export const search = (values = {}) => {
  return async (dispatch, state) => {
    if (!values) values = state?.report?.condition;
    try {
      dispatch({ type: START_SEARCH, payload: { ...values } });
      let data = await search1(values);
      dispatch({ type: SEARCH_COMPLETE, payload: data });
    } catch (error) {
      console.log(error);
      dispatch({ type: SEARCH_ERROR });
      dispatch(setMessage(' '));
    }
  };
};
